'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var LeftNavigationContext = require('./LeftNavigationContext.js');
var ListItemText = require('../../DataDisplay/List/ListItemText.js');
var Typography = require('../../DataDisplay/Typography/Typography.js');
var Badge = require('../../DataDisplay/Badges/Badge.js');
var makeStyles = require('../../Styles/makeStyles.js');
var ListItem = require('../../../node_modules/@material-ui/core/esm/ListItem/ListItem.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ICON_WIDTH = 24;
var useStyles = makeStyles["default"](function (theme) {
  return {
    root: {
      justifyContent: 'space-between',
      alignItems: 'center',
      height: theme.spacing(5),
      '&.Mui-selected': {
        backgroundColor: 'transparent',
        paddingLeft: theme.spacing(4.5),
        transition: 'padding-left 0.5s',
        '&:hover': {
          backgroundColor: 'transparent'
        }
      },
      '&.MuiListItem-button': {
        '&:hover': {
          backgroundColor: 'transparent'
        }
      }
    },
    gutters: {
      paddingLeft: theme.spacing(3),
      transition: 'padding-left 0.5s'
    },
    numericBadge: {
      marginRight: ICON_WIDTH / 2
    }
  };
});

var LeftNavigationItemWithList = function LeftNavigationItemWithList(_ref) {
  var _ref$current2;

  var label = _ref.label,
      badgeValue = _ref.badgeValue,
      value = _ref.value,
      _onClick = _ref.onClick,
      icon = _ref.icon,
      handleTabChange = _ref.handleTabChange,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      rest = objectWithoutProperties(_ref, ["label", "badgeValue", "value", "onClick", "icon", "handleTabChange", "selected"]);

  var _useLeftNavigationCon = LeftNavigationContext.useLeftNavigationContext(),
      setYPosition = _useLeftNavigationCon.setYPosition;

  var _useStyles = useStyles({
    badgeValue: badgeValue
  }),
      root = _useStyles.root,
      gutters = _useStyles.gutters,
      numericBadge = _useStyles.numericBadge;

  var ref = React.useRef(null);
  React.useEffect(function () {
    if (selected && (ref === null || ref === void 0 ? void 0 : ref.current)) {
      var _ref$current;

      setYPosition((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect().top);
    }
  }, [selected, (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.getBoundingClientRect()]);
  return React__default["default"].createElement(ListItem["default"], _objectSpread({
    button: true,
    classes: {
      root: root,
      gutters: gutters
    },
    selected: selected,
    innerRef: ref,
    onClick: function onClick(event) {
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(event);
      handleTabChange && handleTabChange(event, value);
    }
  }, rest), React__default["default"].createElement(ListItemText, {
    primary: React__default["default"].createElement(Typography, {
      variant: selected ? "subtitle2" : "body2",
      noWrap: true
    }, label)
  }), icon && icon, badgeValue && React__default["default"].createElement(Badge, {
    className: numericBadge,
    badgeContent: badgeValue,
    color: "primary"
  }));
};

module.exports = LeftNavigationItemWithList;
